import Image from "next/image";
import Link from "next/link";

import { Heading, Text } from "@/src/components/ui/Typography";
import {
  CursorFollowBadge,
  CursorTrackArea,
} from "@/src/components/molecules/CursorFollowBadge";
import { cn } from "@/src/lib/utils";
import { paths } from "@/src/routes/paths";

import type { CaseStudyCardData } from "./CaseStudyCard.types";

interface CaseStudyCardProps {
  item: CaseStudyCardData;
  className?: string;
}

export function CaseStudyCard({ item, className }: CaseStudyCardProps) {
  if (item.comingSoon) {
    return null;
  }

  return (
    <Link
      href={paths.caseStudies.detail(item.slug)}
      className={cn("group flex flex-col cursor-pointer", className)}
    >
      <Text size="bodySM" className="order-1 mt-7 text-neutral-500 md:order-2">
        {item.cardIndustry}
      </Text>

      <Heading
        as="h3"
        size="headingMD"
        className="order-2 mt-6 text-neutral-700 transition-colors duration-300 group-hover:text-brand md:order-3"
      >
        {item.title}
      </Heading>

      <Text
        size="bodySM"
        className="order-4 mt-4 max-w-100 text-neutral-600 md:order-5"
      >
        {item.cardBlurb}
      </Text>

      <CursorTrackArea className="order-5 mt-4 aspect-4/3 w-full overflow-hidden rounded-(--radius-lg) bg-neutral-100 md:order-1 md:mt-0">
        <Image
          src={item.coverImage}
          alt={item.coverAlt}
          fill
          className="object-cover transition-transform duration-500 ease-out group-hover:scale-105"
        />

        <CursorFollowBadge label="Show case study" className="hidden md:flex" />
      </CursorTrackArea>
    </Link>
  );
}